{
  "title": "Dépôts",
  "list": {
    "title": "Liste des dépôts",
    "search_placeholder": "Rechercher la référence administrative du dépôt",
    "header": {
      "ticket_code_name": "Code interne / Nom de la manifestation",
      "ticket_operation": "Type d'opération",
      "submission_url": "Lien du dépôt IDAHE/EPS",
      "deposit_reference": "Lien du dépôt NTU",
      "remaining_days": "Délais",
      "remaining_days_tooltip": "Si le régime est en déclaration : jours ouvrables sinon jours calendaires",
      "ticket_start_at": "Date de début",
      "ticket_end_at": "Date de fin",
      "submission_regime": "Régime",
      "workflow_step": "Étape de flux",
      "deposit_consignee": "Destinataire",
      "deposit_status": "État du dépôt"
    }
  },
  "filter": {
    "ticket_name": "Nom du ticket",
    "ticket_code": "Code interne",
    "ticket_event_type": "Type d'événement",
    "ticket_operation_name": "Opération",
    "ticket_initiator_id": "Initiateur",
    "event_date_range": "Date de début et de fin",
    "ticket_submission_regime": "Régime de soumission",
    "ticket_workflow_step_or_status": "Étape de flux",
    "status": "Statut du dépôt"
  },
  "day_type": {
    "WORKING": "Jours ouvrés",
    "BUSINESS": "Jours ouvrables",
    "CALENDAR": "Jours calendaires"
  }
}
